import React from 'react';

export const useBroadcastChannel = (channelId, isSafari, onmessage) => {
  const channel = React.useRef(null);
  /* eslint-disable consistent-return */
  React.useEffect(() => {
    if (!isSafari) {
      channel.current = new window.BroadcastChannel(channelId);
      if (onmessage) channel.current.onmessage = onmessage;
      channel.current.onmessageerror = ev => {
        throw new Error(
          `BroadcastChannel Error while deserializing:  + ${ev.origin}`,
        );
      };
      return () => channel.current && channel.current.close();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // This can be used in scnerios where we can send message if the component has received certain message
  const post = message => channel.current.postMessage(message);
  return [post];
};
